import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// Страница ставок

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export interface IRatesChartEvent {
  type: string;
  sum: string;
  term: string;
  month: string;
}

export interface ISendOfferParams {
  calcId: string;
  productId: string;
  organizationId: string;
  organizationName: string;
  productName: string;
  position: number;
  group: string;
}

export const eventRatesChartInit = (data: IRatesChartEvent): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: `Показ компонента ставок`,
  eventLabel: Object.values(data),
  eventValue: undefined,
});

export const eventPaidClick = (data: ISendOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Платный клик',
  eventLabel: [
    data.calcId,
    data.productId,
    data.organizationId,
    data.organizationName,
    data.productName,
    data.position,
    `Листинг - ${data.group}`,
  ].join('|'),
  eventValue: undefined,
});

export const eventSendOffer = (data: ISendOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: `Шаг 5|Заявка отправлена`,
  eventLabel: [
    data.calcId,
    data.productId,
    data.organizationId,
    data.organizationName,
    data.productName,
    data.position,
    `Листинг - ${data.group}`,
  ].join('|'),
  eventValue: undefined,
});

export const eventRatesChartChange = (label: string, value: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: `Компонент ставок|Изменение параметра`,
  eventLabel: [label, value],
  eventValue: undefined,
});

export const eventRatesChartViewItem = (label: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Компонент ставок|Просмотр ставки',
  eventLabel: label,
  eventValue: undefined,
});

export const eventRatesChartSelectItem = (label: string, data: IRatesChartEvent): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Компонент ставок|Переход в подбор',
  eventLabel: [label, ...Object.values(data)],
  eventValue: undefined,
});
